// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
    margin:0;
    overflow-x:hidden;
}

.footer_main{

    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-size:24px;
    padding: 20px;
    font-family: 'Play', sans-serif;
    text-align:center;
    border-top: 1px solid #5b5765;
    border-bottom: 1px solid #5b5765;
}

.footer_main .links{
    display: flex;
    justify-content: center;
    gap:3rem;
    flex-wrap: wrap;
    color:white;
    font-size:0.6em;
}

.footer_main .links a{
    text-decoration:none;
    color:white;
    transition:0.5s;
}

.footer_main .links a:hover{
    color:#fff;
}



.footer_main .row a i{
    font-size:2em;
    margin:0% 1%;
}

@media (max-width:720px){
    .footer_main{
        text-align:left;
        padding:5%;
    }
   .footer_main .links{


    gap:1rem;
   }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer_global.css"],"names":[],"mappings":"AAAA;IACI,QAAQ;IACR,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,aAAa;IACb,+BAA+B;IAC/B,iBAAiB;IACjB,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;;;AAIA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI;QACI,eAAe;QACf,UAAU;IACd;GACD;;;IAGC,QAAQ;GACT;AACH","sourcesContent":["body{\n    margin:0;\n    overflow-x:hidden;\n}\n\n.footer_main{\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    font-size:24px;\n    padding: 20px;\n    font-family: 'Play', sans-serif;\n    text-align:center;\n    border-top: 1px solid #5b5765;\n    border-bottom: 1px solid #5b5765;\n}\n\n.footer_main .links{\n    display: flex;\n    justify-content: center;\n    gap:3rem;\n    flex-wrap: wrap;\n    color:white;\n    font-size:0.6em;\n}\n\n.footer_main .links a{\n    text-decoration:none;\n    color:white;\n    transition:0.5s;\n}\n\n.footer_main .links a:hover{\n    color:#fff;\n}\n\n\n\n.footer_main .row a i{\n    font-size:2em;\n    margin:0% 1%;\n}\n\n@media (max-width:720px){\n    .footer_main{\n        text-align:left;\n        padding:5%;\n    }\n   .footer_main .links{\n\n\n    gap:1rem;\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
